export interface EntityStepperState {
  step: number;
}

export const initialState: EntityStepperState = {
  step: 1
};
